// AUTO-GENERATED by scripts/gen-county-tick-status.mjs — do not edit by hand.
// Which CDC county file the site cites. The FIPS lists are in ./county-tick-status.ts.
export const COUNTY_TICK_STATUS_SOURCE_URL = "https://www.cdc.gov/ticks/media/files/2026/05/2025-lone-star-tick-surveillance-map-data.xlsx";
export const COUNTY_TICK_STATUS_YEAR = 2025;
